/** Captured from Clients List Facesheet Settings modal. */
export const FACESHEET_COLUMNS_SETTINGS = {
  "sections": [
    {
      "title": "General Information",
      "rows": [
        {
          "value": "CLIENT NAME",
          "label": "CLIENT NAME",
          "priority": "1",
          "checked": true,
          "locked": true
        },
        {
          "value": "CLIENT ID",
          "label": "CLIENT ID",
          "priority": "2",
          "checked": true,
          "locked": true
        },
        {
          "value": "FRIST NAME",
          "label": "FIRST NAME",
          "priority": "3",
          "checked": true,
          "locked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "priority": "4",
          "checked": true,
          "locked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "priority": "5",
          "checked": true,
          "locked": false
        },
        {
          "value": "LANGUAGE DISPLAY NAME",
          "label": "LANGUAGE DISPLAY NAME",
          "priority": "85",
          "checked": false,
          "locked": false
        },
        {
          "value": "SEX",
          "label": "SEX",
          "priority": "6",
          "checked": true,
          "locked": false
        },
        {
          "value": "HOME PHONE",
          "label": "HOME PHONE",
          "priority": "7",
          "checked": true,
          "locked": false
        },
        {
          "value": "CELL PHONE",
          "label": "CELL PHONE",
          "priority": "8",
          "checked": true,
          "locked": false
        },
        {
          "value": "DATE OF BIRTH",
          "label": "DATE OF BIRTH",
          "priority": "9",
          "checked": true,
          "locked": true
        },
        {
          "value": "ADMISSION DATE",
          "label": "ADMISSION DATE",
          "priority": "10",
          "checked": true,
          "locked": false
        },
        {
          "value": "CLIENT EMAIL ID",
          "label": "CLIENT EMAIL ID",
          "priority": "11",
          "checked": true,
          "locked": false
        },
        {
          "value": "SOCIAL SECURITY",
          "label": "SOCIAL SECURITY",
          "priority": "12",
          "checked": true,
          "locked": false
        },
        {
          "value": "ADDRESS 1",
          "label": "ADDRESS 1",
          "priority": "13",
          "checked": true,
          "locked": false
        },
        {
          "value": "COUNTRY",
          "label": "COUNTRY",
          "priority": "14",
          "checked": true,
          "locked": false
        },
        {
          "value": "ADDRESS 2",
          "label": "ADDRESS 2",
          "priority": "15",
          "checked": true,
          "locked": false
        },
        {
          "value": "STATE",
          "label": "STATE",
          "priority": "16",
          "checked": true,
          "locked": false
        },
        {
          "value": "CITY",
          "label": "CITY",
          "priority": "17",
          "checked": true,
          "locked": false
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "priority": "18",
          "checked": true,
          "locked": false
        },
        {
          "value": "COORDINATES(LATITUDE)",
          "label": "COORDINATES(LATITUDE)",
          "priority": "19",
          "checked": false,
          "locked": false
        },
        {
          "value": "COORDINATES(LONGITUDE)",
          "label": "COORDINATES(LONGITUDE)",
          "priority": "20",
          "checked": false,
          "locked": false
        },
        {
          "value": "COUNTY",
          "label": "COUNTY",
          "priority": "84",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT ADDRESS 1",
          "label": "ALTERNATIVE ADDRESS 1",
          "priority": "76",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT COUNTRY",
          "label": "ALTERNATIVE COUNTRY",
          "priority": "77",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT ADDRESS 2",
          "label": "ALTERNATIVE ADDRESS 2",
          "priority": "78",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT STATE",
          "label": "ALTERNATIVE STATE",
          "priority": "79",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT CITY",
          "label": "ALTERNATIVE CITY",
          "priority": "80",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT ZIP CODE",
          "label": "ALTERNATIVE ZIP CODE",
          "priority": "81",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT COORDINATES(LATITUDE)",
          "label": "ALTERNATIVE COORDINATES(LATITUDE)",
          "priority": "82",
          "checked": false,
          "locked": false
        },
        {
          "value": "ALT COORDINATES(LONGITUDE)",
          "label": "ALTERNATIVE COORDINATES(LONGITUDE)",
          "priority": "83",
          "checked": false,
          "locked": false
        },
        {
          "value": "PROFILE PHOTO",
          "label": "PROFILE PHOTO",
          "priority": "21",
          "checked": true,
          "locked": false
        },
        {
          "value": "SOCIAL SECURITY CARD IMAGE",
          "label": "SOCIAL SECURITY CARD IMAGE",
          "priority": "22",
          "checked": true,
          "locked": false
        },
        {
          "value": "MARITAL STATUS",
          "label": "MARITAL STATUS",
          "priority": "23",
          "checked": true,
          "locked": false
        },
        {
          "value": "GUARDIAN",
          "label": "GUARDIAN",
          "priority": "24",
          "checked": true,
          "locked": false
        },
        {
          "value": "GUARDIAN NAME",
          "label": "GUARDIAN NAME",
          "priority": "25",
          "checked": true,
          "locked": false
        },
        {
          "value": "GUARDIAN PHONE",
          "label": "GUARDIAN PHONE",
          "priority": "26",
          "checked": true,
          "locked": false
        },
        {
          "value": "PROXY",
          "label": "PROXY",
          "priority": "27",
          "checked": true,
          "locked": false
        },
        {
          "value": "PROXY NAME",
          "label": "PROXY NAME",
          "priority": "28",
          "checked": true,
          "locked": false
        },
        {
          "value": "PROXY PHONE",
          "label": "PROXY PHONE",
          "priority": "29",
          "checked": true,
          "locked": false
        },
        {
          "value": "PRIMARY LANGUAGE",
          "label": "PRIMARY LANGUAGE",
          "priority": "30",
          "checked": true,
          "locked": false
        },
        {
          "value": "SECONDARY LANGUAGE",
          "label": "SECONDARY LANGUAGE",
          "priority": "31",
          "checked": true,
          "locked": false
        },
        {
          "value": "CODE STATUS",
          "label": "CODE STATUS",
          "priority": "32",
          "checked": true,
          "locked": false
        },
        {
          "value": "ETHNICITY",
          "label": "ETHNICITY",
          "priority": "33",
          "checked": true,
          "locked": false
        },
        {
          "value": "RELIGION",
          "label": "RELIGION",
          "priority": "34",
          "checked": true,
          "locked": false
        },
        {
          "value": "PROGRAM NAME",
          "label": "PROGRAM NAME",
          "priority": "35",
          "checked": true,
          "locked": false
        },
        {
          "value": "COMMENTS",
          "label": "COMMENTS",
          "priority": "36",
          "checked": true,
          "locked": false
        },
        {
          "value": "SPOUSE'S/SIGNIFICANT OTHER'S NAME",
          "label": "SPOUSE'S/SIGNIFICANT OTHER'S NAME",
          "priority": "37",
          "checked": true,
          "locked": false
        },
        {
          "value": "AGE",
          "label": "AGE",
          "priority": "75",
          "checked": true,
          "locked": false
        },
        {
          "value": "MOBILITY ID #",
          "label": "MOBILITY ID #",
          "priority": "85",
          "checked": false,
          "locked": false
        },
        {
          "value": "VETERAN",
          "label": "VETERAN",
          "priority": "88",
          "checked": false,
          "locked": false
        },
        {
          "value": "RESIDENCE STATUS",
          "label": "RESIDENCE STATUS",
          "priority": "89",
          "checked": false,
          "locked": false
        }
      ]
    },
    {
      "title": "Additional Information",
      "rows": [
        {
          "value": "ALLERGIES",
          "label": "ALLERGIES",
          "priority": "38",
          "checked": true,
          "locked": false
        },
        {
          "value": "ADVANCED DIRECTIVES",
          "label": "ADVANCED DIRECTIVES",
          "priority": "39",
          "checked": true,
          "locked": false
        },
        {
          "value": "HOSPITAL PREFERENCE",
          "label": "HOSPITAL PREFERENCE",
          "priority": "40",
          "checked": true,
          "locked": false
        },
        {
          "value": "DIAGNOSIS",
          "label": "DIAGNOSIS",
          "priority": "41",
          "checked": true,
          "locked": false
        },
        {
          "value": "BILLING DIAGNOSIS",
          "label": "BILLING DIAGNOSIS",
          "priority": "42",
          "checked": true,
          "locked": false
        },
        {
          "value": "DIAGNOSIS DESCRIPTION",
          "label": "DIAGNOSIS DESCRIPTION",
          "priority": "43",
          "checked": false,
          "locked": false
        },
        {
          "value": "ADDITIONAL HISTORY",
          "label": "ADDITIONAL HISTORY",
          "priority": "44",
          "checked": true,
          "locked": false
        },
        {
          "value": "MANAGED LONG TERM SERVICE",
          "label": "MANAGED LONG TERM SERVICE",
          "priority": "45",
          "checked": true,
          "locked": false
        },
        {
          "value": "CASE MANAGER NAME",
          "label": "CASE MANAGER NAME",
          "priority": "46",
          "checked": true,
          "locked": false
        },
        {
          "value": "CASE MANAGER PHONE",
          "label": "CASE MANAGER PHONE",
          "priority": "47",
          "checked": true,
          "locked": false
        },
        {
          "value": "CASE MANAGER EMAIL ID",
          "label": "CASE MANAGER EMAIL ID",
          "priority": "48",
          "checked": true,
          "locked": false
        },
        {
          "value": "EXTENSION",
          "label": "EXTENSION",
          "priority": "49",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHOTO ID",
          "label": "PHOTO ID",
          "priority": "71",
          "checked": false,
          "locked": false
        },
        {
          "value": "ELIGIBILITY DATE",
          "label": "ELIGIBILITY DATE",
          "priority": "72",
          "checked": false,
          "locked": false
        },
        {
          "value": "ENROLLMENT DATE",
          "label": "ENROLLMENT DATE",
          "priority": "73",
          "checked": false,
          "locked": false
        },
        {
          "value": "WITHDRAWAL DATE",
          "label": "WITHDRAWAL DATE",
          "priority": "74",
          "checked": false,
          "locked": false
        }
      ]
    },
    {
      "title": "Header Settings :",
      "rows": [
        {
          "value": "HEADER CLIENT NAME",
          "label": "CLIENT NAME",
          "priority": "50",
          "checked": true,
          "locked": false
        },
        {
          "value": "GENDER",
          "label": "GENDER",
          "priority": "51",
          "checked": true,
          "locked": false
        },
        {
          "value": "DOB",
          "label": "DOB",
          "priority": "52",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHYSICIAN",
          "label": "PHYSICIAN",
          "priority": "53",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHYSICIAN PHONE",
          "label": "PHYSICIAN PHONE",
          "priority": "54",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHYSICIAN FAX",
          "label": "PHYSICIAN FAX",
          "priority": "55",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHARMACY",
          "label": "PHARMACY",
          "priority": "56",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHARMACY PHONE",
          "label": "PHARMACY PHONE",
          "priority": "57",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHARMACY FAX",
          "label": "PHARMACY FAX",
          "priority": "66",
          "checked": true,
          "locked": false
        },
        {
          "value": "HEADER MEDICARE",
          "label": "MEDICARE",
          "priority": "58",
          "checked": true,
          "locked": false
        },
        {
          "value": "HEADER MEDICAID",
          "label": "MEDICAID",
          "priority": "59",
          "checked": true,
          "locked": false
        },
        {
          "value": "ELIGIBILITY VERIFICATION",
          "label": "HMO MEMBER",
          "priority": "60",
          "checked": true,
          "locked": false
        },
        {
          "value": "ELIGIBILITY_VERIFICATION_HMO_PLAN",
          "label": "HMO PLAN",
          "priority": "92",
          "checked": false,
          "locked": false
        },
        {
          "value": "RECENT VITALS",
          "label": "RECENT VITALS",
          "priority": "61",
          "checked": true,
          "locked": false
        },
        {
          "value": "HEADER ALLERGIES",
          "label": "ALLERGIES",
          "priority": "62",
          "checked": true,
          "locked": false
        },
        {
          "value": "HEADER CODE STATUS",
          "label": "CODE STATUS",
          "priority": "63",
          "checked": true,
          "locked": false
        },
        {
          "value": "HEADER PROFILE PHOTO",
          "label": "PROFILE PHOTO",
          "priority": "64",
          "checked": true,
          "locked": false
        },
        {
          "value": "HEADER DIAGNOSIS",
          "label": "DIAGNOSIS",
          "priority": "65",
          "checked": true,
          "locked": false
        },
        {
          "value": "AGE_MAIN",
          "label": "AGE",
          "priority": "86",
          "checked": false,
          "locked": false
        },
        {
          "value": "BMI",
          "label": "BMI CALCULATION",
          "priority": "87",
          "checked": false,
          "locked": false
        },
        {
          "value": "HEADER CASE MANAGER NAME",
          "label": "CASE MANAGER NAME",
          "priority": "90",
          "checked": false,
          "locked": false
        },
        {
          "value": "HEADER CASE MANAGER CONTACTS",
          "label": "CASE MANAGER CONTACTS",
          "priority": "91",
          "checked": false,
          "locked": false
        },
        {
          "value": "HEADER ADMISSION DATE",
          "label": "ADMISSION DATE",
          "priority": "93",
          "checked": false,
          "locked": false
        }
      ]
    },
    {
      "title": "Section Settings :",
      "rows": [
        {
          "value": "PROFILE DETAILS",
          "label": "PROFILE DETAILS",
          "priority": "65",
          "checked": true,
          "locked": false
        },
        {
          "value": "CONTACTS",
          "label": "CONTACTS",
          "priority": "66",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHYSICIAN LIST",
          "label": "PHYSICIAN LIST",
          "priority": "67",
          "checked": true,
          "locked": false
        },
        {
          "value": "PHARMACY LIST",
          "label": "PHARMACY LIST",
          "priority": "68",
          "checked": true,
          "locked": false
        },
        {
          "value": "ELIGIBILITY & PRIOR AUTHENTICATION SECTION",
          "label": "ELIGIBILITY & PRIOR AUTHENTICATION",
          "priority": "69",
          "checked": true,
          "locked": false
        },
        {
          "value": "MEDICARE INFORMATION SECTION",
          "label": "MEDICARE INFORMATION",
          "priority": "70",
          "checked": false,
          "locked": false
        }
      ]
    }
  ],
  "toggles": [
    {
      "title": "Transfer Information",
      "name": "cli_columns_setting_trans",
      "options": [
        {
          "value": "TRANSFER INFO YES",
          "checked": true
        },
        {
          "value": "TRANSFER INFO NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Payer (Insurance) Details",
      "name": "cli_columns_setting_payer",
      "options": [
        {
          "value": "PAYER INFO YES",
          "checked": true
        },
        {
          "value": "PAYER INFO NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Referral Details",
      "name": "cli_columns_setting_referral",
      "options": [
        {
          "value": "REFERRAL INFO YES",
          "checked": true
        },
        {
          "value": "REFERRAL INFO NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Schedule Details (Attendance Schedule)",
      "name": "cli_columns_setting_att",
      "options": [
        {
          "value": "ATTENDANCE SCHEDULE YES",
          "checked": true
        },
        {
          "value": "ATTENDANCE SCHEDULE NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Schedule Details (Transportation Schedule)",
      "name": "cli_columns_setting_transs",
      "options": [
        {
          "value": "TRANSPORTATION SCHEDULE YES",
          "checked": true
        },
        {
          "value": "TRANSPORTATION SCHEDULE NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Schedule Details (Transportation Variation Time)",
      "name": "cli_columns_setting_trans_variation",
      "options": [
        {
          "value": "TRANSPORTATION VARIATION TIME YES",
          "checked": false
        },
        {
          "value": "TRANSPORTATION VARIATION TIME NO",
          "checked": true
        }
      ]
    },
    {
      "title": "Food Details (Meal Details)",
      "name": "cli_columns_setting_food",
      "options": [
        {
          "value": "FOOD MEAL YES",
          "checked": true
        },
        {
          "value": "FOOD MEAL NO",
          "checked": false
        }
      ]
    },
    {
      "title": "Home Health Details",
      "name": "cli_columns_setting_health",
      "options": [
        {
          "value": "HOME HEALTH YES",
          "checked": false
        },
        {
          "value": "HOME HEALTH NO",
          "checked": true
        }
      ]
    },
    {
      "title": "Home Delivered Details",
      "name": "cli_columns_setting_deli",
      "options": [
        {
          "value": "HOME DELIVERED YES",
          "checked": false
        },
        {
          "value": "HOME DELIVERED NO",
          "checked": true
        }
      ]
    },
    {
      "title": "Signature Details",
      "name": "cli_columns_setting_sign",
      "options": [
        {
          "value": "SIGNATURE YES",
          "checked": true
        },
        {
          "value": "SIGNATURE NO",
          "checked": false
        }
      ]
    },
    {
      "title": "AUTO FILL FOR CLIENT NAME   FIRST NAME First Name Last Name LAST NAME Last Name First Name MIDDLE NAME NO YES",
      "name": "cli_columns_setting_autofill_client",
      "options": [
        {
          "value": "AUTO FILL FOR CLIENT NAME YES",
          "checked": false
        },
        {
          "value": "AUTO FILL FOR CLIENT NAME NO",
          "checked": true
        }
      ]
    },
    {
      "title": "LOC",
      "name": "cli_columns_setting_loc",
      "options": [
        {
          "value": "LOC YES",
          "checked": false
        },
        {
          "value": "LOC NO",
          "checked": true
        }
      ]
    },
    {
      "title": "Care Manager",
      "name": "cli_columns_setting_care_manager",
      "options": [
        {
          "value": "CARE MANAGER YES",
          "checked": false
        },
        {
          "value": "CARE MANAGER NO",
          "checked": true
        }
      ]
    },
    {
      "title": "CLIENT ID # AUTO INCREMENT",
      "name": "cli_id_auto_increment",
      "options": [
        {
          "value": "CLIENTID AUTO INCREMENT YES",
          "checked": false
        },
        {
          "value": "CLIENTID AUTO INCREMENT NO",
          "checked": true
        }
      ]
    }
  ]
} as const
